import Vue from 'vue';
import http from './http_services';
import storage from './mod_storage';
import manipulation_helpers from './mod_manipulation_helpers';

const categories = {
  expiration_minutes: 60,
	state: {
		super_category_list: []
	},

  get_current_super_category_list: function() {
    return this.state.super_category_list;
  },

  refresh_super_category_list: function(instanceid) {
    let vm = this;
    
    // CHECK STORAGE FIRST
    storage.get_item('super_category_list')
      .then(function(vf_response) {
        // console.log('vf_response: ', vf_response);
        if(vf_response) {
          if(vf_response.length > 0) {
            // DATA IS STILL VALID. LOAD IT.
            Vue.set(vm.state, 'super_category_list', vf_response);
          }
          else {
            // GET FROM DB
            vm.fetch_super_category_list(instanceid)
              .then(function(response) {
                // SAVE TO LOCAL STATE
                Vue.set(vm.state, 'super_category_list', response.data.data);

                // SAVE TO STORAGE
                storage.set_item('super_category_list', vm.state.super_category_list);
              })
          }
        }
        else {
          // GET FROM DB
          vm.fetch_super_category_list(instanceid)
            .then(function(response) {
              // SAVE TO LOCAL STATE
              Vue.set(vm.state, 'super_category_list', response.data.data);

              // SAVE TO STORAGE
              storage.set_item('super_category_list', vm.state.super_category_list);
            })
        }
      })
      .catch(function(error) {
        console.log('error: ', error);
      })
    
  },

  fetch_super_category_list: function(instanceid) {
    let vm = this;
    let requested_set = 'all_super_categories';

    return http.get_api_data(requested_set, {instanceid: instanceid});
  }
}

export default categories


// WEBPACK FOOTER //
// ./src/store/modules/mod_categories.js